export const buildClinicalHistoryDefault = () => ({
  fastingStatus: { isFasting: false, hours: "" },
  medicalHistory: {
    diabetes: false,
    hypertension: false,
    thyroidDisorder: false,
    kidneyDisease: false,
    liverDisease: false,
    asthmaCopd: false,
    noKnownMedicalHistory: false,
  },
  drugHistory: {
    onMedication: false,
    antibiotics: false,
    steroids: false,
    bloodThinners: false,
    noKnownMedicationHistory: false,
  },
  viralMarkerHistory: {
    hiv: false,
    hbsAg: false,
    hcv: false,
  },
  specialConditions: {
    pregnancy: false,
    recentBloodTransfusion: false,
    allergyHistory: false,
    faintingHistory: false,
    noKnownSpecialConditions: false,
  },
  clinicalHistory: "",
  remarks: "",
});

export const fromApiClinicalHistory = (apiValue) => {
  let parsed = apiValue;
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      parsed = null;
    }
  }
  const base = buildClinicalHistoryDefault();
  if (!parsed) return base;
  return {
    ...base,
    ...parsed,
    fastingStatus: {
      isFasting: !!parsed?.fastingStatus?.isFasting,
      hours:
        parsed?.fastingStatus?.hours != null &&
        parsed?.fastingStatus?.hours !== ""
          ? String(parsed?.fastingStatus?.hours)
          : "",
    },
    medicalHistory: {
      ...base.medicalHistory,
      ...(parsed?.medicalHistory || {}),
    },
    drugHistory: {
      ...base.drugHistory,
      ...(parsed?.drugHistory || {}),
    },
    viralMarkerHistory: {
      ...base.viralMarkerHistory,
      ...(parsed?.viralMarkerHistory || {}),
    },
    specialConditions: {
      ...base.specialConditions,
      ...(parsed?.specialConditions || {}),
    },
    clinicalHistory: parsed?.clinicalHistory || "",
    remarks: parsed?.remarks || "",
  };
};
